import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 33 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.983 10.55c.015.276.24.5.517.5a.505.505 0 0 0 .502-.5c.01-.735.07-1.35.406-2.606 1.11-4.14 4.346-6.375 8.486-7.485C27.42.05 29.28 0 33 0H0c3.72 0 5.58.05 7.105.459 4.141 1.11 7.377 3.344 8.487 7.485.267.998.36 2.02.391 2.607Z"
      fill="#007AFF"
    />
  </svg>
);
const Memo = memo(SvgPip);
export default Memo;
